import Helpers from "@/util/Helpers";

export default ({ instance, baseURL, headers}) => {
    const apiCalls = {

        ListarCredenciaisInternas(filters) {
            return instance({
                method: 'post',
                baseURL,
                url: 'CredencialInterna/ListarCredenciaisInternas',
                responseType: 'json',
                headers: headers,
                data: Helpers.aplicarValidacoes(filters),
            });
        },
        inserirCredencialInterna(credencialInterna, idFonte, idPerfil) {
            return instance({
                method: 'post',
                baseURL,
                url: 'CredencialInterna/InserirCredencialInterna',
                responseType: 'json',
                headers: headers,
                data: Helpers.aplicarValidacoes({ 'credencialInterna':credencialInterna, 'idFonte': idFonte, 'idPerfil': idPerfil }),
            });
        },
        atualizarCredencialInterna(credencialInterna, idUserAlteracao, idFonte) {
            return instance({
                method: 'post',
                baseURL,
                url: 'CredencialInterna/EditarCredencialInterna',
                responseType: 'json',
                headers: headers,
                data: Helpers.aplicarValidacoes({ 'credencialInterna': credencialInterna, 'idUserAlteracao': idUserAlteracao, 'idFonte': idFonte }),
            })
        },
        getCredencialFontes(){
            return instance({
                method: 'get',
                baseURL,
                url: 'CredencialInterna/RecuperarFontes',
                responseType: 'json',
                headers: headers,
            });
        },
    }
    return apiCalls;
}